import * as Sentry from '@sentry/react';
import pako from 'pako';
import type { Bntrk } from '~/shared/bntrk';

const fromBase64Url = (str: string): Uint8Array => {
  const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
};

const decode = (encoded: string): Bntrk | null => {
  try {
    const compressed = fromBase64Url(encoded);
    const json = pako.inflate(compressed, { to: 'string' });
    return JSON.parse(json) as Bntrk;
  } catch {
    Sentry.captureException(new Error('Failed to decode Bntrk data'));
    return null;
  }
};

export default decode;
